"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _polygon.default;
  }
});
Object.defineProperty(exports, "_Polygon", {
  enumerable: true,
  get: function get() {
    return _polygon.default;
  }
});
Object.defineProperty(exports, "getPolygonSignedArea", {
  enumerable: true,
  get: function get() {
    return _polygonUtils.getPolygonSignedArea;
  }
});
Object.defineProperty(exports, "getPolygonWindingDirection", {
  enumerable: true,
  get: function get() {
    return _polygonUtils.getPolygonWindingDirection;
  }
});
Object.defineProperty(exports, "forEachSegmentInPolygon", {
  enumerable: true,
  get: function get() {
    return _polygonUtils.forEachSegmentInPolygon;
  }
});
Object.defineProperty(exports, "modifyPolygonWindingDirection", {
  enumerable: true,
  get: function get() {
    return _polygonUtils.modifyPolygonWindingDirection;
  }
});
Object.defineProperty(exports, "WINDING", {
  enumerable: true,
  get: function get() {
    return _polygonUtils.WINDING;
  }
});
Object.defineProperty(exports, "earcut", {
  enumerable: true,
  get: function get() {
    return _earcut.earcut;
  }
});
Object.defineProperty(exports, "clipPolygon", {
  enumerable: true,
  get: function get() {
    return _lineclip.clipPolygon;
  }
});
Object.defineProperty(exports, "clipPolyline", {
  enumerable: true,
  get: function get() {
    return _lineclip.clipPolyline;
  }
});
Object.defineProperty(exports, "cutPolygonByGrid", {
  enumerable: true,
  get: function get() {
    return _cutByGrid.cutPolygonByGrid;
  }
});
Object.defineProperty(exports, "cutPolylineByGrid", {
  enumerable: true,
  get: function get() {
    return _cutByGrid.cutPolylineByGrid;
  }
});
Object.defineProperty(exports, "cutPolylineByMercatorBounds", {
  enumerable: true,
  get: function get() {
    return _cutByMercatorBounds.cutPolylineByMercatorBounds;
  }
});
Object.defineProperty(exports, "cutPolygonByMercatorBounds", {
  enumerable: true,
  get: function get() {
    return _cutByMercatorBounds.cutPolygonByMercatorBounds;
  }
});

var _polygon = _interopRequireDefault(require("./polygon"));

var _polygonUtils = require("./polygon-utils");

var _earcut = require("./earcut");

var _lineclip = require("./lineclip");

var _cutByGrid = require("./cut-by-grid");

var _cutByMercatorBounds = require("./cut-by-mercator-bounds");
//# sourceMappingURL=index.js.map